// Island Mode gate (docs/ISLAND-MODE.md). The only island code in the main bundle. It sets
// data-layout on the root, loads the island chunk (its own JS + CSS) the first time the layout is
// "island", keeps the latest word from each activity source until the chunk is running, and gives
// the island the first look at keys. A Classic visitor never fetches the chunk.
let api = null, loading = null;
const last = new Map(); // activity kind -> latest data, read by the chunk when it starts

export const islandOn = () => document.documentElement.dataset.layout === "island";

// Bell, music, Study Hall, focus timer and update news. Cheap when the island is not loaded.
export function emitIsland(kind, data) {
	last.set(kind, data);
	if (api) api.activity(kind, data);
}
// True when the island handled the key (Ctrl+K, Alt+L, Alt+I, ...).
export const islandKey = (e) => !!(api && islandOn() && api.key(e));
// "Focus the address bar" in this layout opens the island's search with the address selected.
// With `q`, the search opens with that text instead (a link handed off from another tab).
export const islandAddr = (q) => !!(api && islandOn() && api.addr(q) !== false);
// Hands focus to the island's search (onboarding's Done, for one).
export const focusIsland = () => !!(api && islandOn() && api.focus() !== false);

export function initIsland(ctx) {
	const root = document.documentElement;
	const sync = () => {
		const on = ctx.get("layout") === "island" && !ctx.inOS;
		if (on === islandOn() && (!on || loading)) return;
		if (on) root.dataset.layout = "island"; else delete root.dataset.layout;
		if (on && !loading) {
			const css = document.createElement("link");
			css.rel = "stylesheet"; css.href = __RVM.islandCss;
			const ready = new Promise((r) => { css.onload = css.onerror = r; });
			document.head.appendChild(css);
			const url = __RVM.islandJs;
			loading = Promise.all([import(url), ready]).then(([m]) => { api = m.start(ctx, last); }).catch(() => {
				// No island this visit (offline, a blocked file): Classic still works.
				loading = null;
				delete root.dataset.layout;
				ctx.render();
			});
		}
		if (api) api.layout(on);
		ctx.render();
	};
	ctx.subscribe(sync);
	sync();
}
